import { useCartStore } from "../../../../hooks/stores/useCartStore";
import { IconShoppingCart } from "@tabler/icons-react";
interface CartIconProps {
    onClick: () => void;
    className?: string;
}
export function CartIcon({ onClick, className = "" }: CartIconProps) {
    const { getTotalItems } = useCartStore();
    const itemCount = getTotalItems();
    return (<button onClick={onClick} className={`relative inline-flex size-10 items-center justify-center text-primary hover:text-primary/80 transition-colors ${className}`} aria-label={`Shopping cart with ${itemCount} items`}>
      <IconShoppingCart size={24}/>
      {itemCount > 0 && (<span className="absolute -top-1 -right-1 bg-primary text-white text-xs font-semibold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1">
          {itemCount > 99 ? "99+" : itemCount}
        </span>)}
    </button>);
}
